/**
 * @author Blueprint Frontend Team
 */
import "../scss/index.scss";
import { header, home, menu } from './layouts';
import { slider, tabs, accordion, sliderThumbAnimation, contactForm } from './components';

import { loadPage } from './utils';

(function () {
  loadPage.init();

  // Layouts
  header.init();
  home.init();
  menu.init();


  // Partials Modules
  slider.init();
  tabs.init();
  accordion.init();
  sliderThumbAnimation.init();
  contactForm.init();


  // Page Modules
}());
